import React,{useState} from 'react'
import pic from '../assets/img/login-dark.png'
import icon from '../assets/img/favicon.icon'
import { Link } from 'react-router-dom'
import swal from 'sweetalert'
import { useNavigate } from 'react-router-dom'
export default function Login() {
  const [username,setUserName]=useState('');
  const [password,setPassword]=useState('');
  const navigate=useNavigate();
  const loggin=()=>{
    // alert(4)
    if(username==='' && password===''){
      swal("نام کاربری و رمز عبور خود را وارد کنید")
    }else {
      const url=new URL('https://66caec954290b1c4f1990ef1.mockapi.io/register');
      url.searchParams.append('email', username); 
      url.searchParams.append('password', password); 
      fetch(url,{
        method:'GET',
        headers: {'content-type':'application/json'},
      }).then(res=>{
          if(res.ok){
            return res.json();
          }
          
      }).then(data=>{
          swal(" ورود شما با موفقیت انجام شد")
          navigate('/home')
      }).catch(err=>{
        swal("نام کاربری و رمز عبور خود را وارد کنید")
      })
    }
  }
  return (
    <>
        <section className='w-full h-[100vh] flex-row-reverse flex justify-center items-center *:h-full overflow-x-hidden'>
              <section className='bg-[#283144] flex  justify-center items-center h-full w-full md:w-1/3'>
                    <section className='w-[80%]  h-[80%] flex flex-wrap  justify-center items-center  *:h-1/11 *:w-full '>
                          <div className='flex items-center *:px-1 *:h-full'>
                              <figure>
                                <img className='object-cover w-10 h-10' src={icon} alt="Logo" />
                              </figure>

                              <span className='text-2xl font-semibold text-[#D8DEEA]'>
                                  فرست
                              </span>
                          </div>
                          <div className=''>
                              <h4 className='text-[#D8DEEA]  font-medium h-full text-2xl'>به فرست خوش آمدید!</h4>
                          </div>
                          <div className=''>
                            <span className='text-[#a1b0cb]'>لطفا وارد حساب خود شده و ماجراجویی را شروع کنید</span>
                          </div>
                          <div className='flex flex-wrap *:py-1'>
                              <label className='w-full text-[1rem] text-[#546990]' >نام کاربری یا ایمیل </label>
                              <input onChange={(e)=>setUserName(e.target.value)}  type="text" className="w-full outline-0 bg-transparent focus:border-[#5a8dee] border border-[#546990] h-10 p-2 rounded" placeholder='ایمیل یا نام کاربری خود را وارد کنید'/>
                          </div>
                          
                          <div className='flex flex-wrap *:py-1'>
                              <div className='w-full flex justify-between items-center *:py-1'>
                              <span className='w-full text-[1rem] text-[#546990]'> رمز عبور</span>
                              <span className='w-full flex justify-end text-[0.75rem] text-[#6B98F0]' > رمز عبور را فراموش کردید؟ </span>
                              </div>
                              <input onChange={(e)=>setPassword(e.target.value)}  type="password" aria-describedby="password" className="w-full text-[#546990] outline-0 bg-transparent focus:border-[#5a8dee] border border-[#546990] h-10 p-2 rounded" placeholder='........'/>
                          </div>
                         
                          <div className='flex items-center  *:px-1'>
                                <div className='flex items-center   h-full'>
                                <input type='checkbox'   className='w-fit  bg-transparent focus:border-[#5a8dee] border border-[#546990]  rounded'  required />
                                <span className='h-full flex  font-semibold px-1 text-[#546990]'> به خاطر سپاری   </span>
                               
                               
                                </div>

                               
                          </div>
                          <div className='flex justify-center items-center'>
                              <button onClick={loggin} className='w-full h-10 hover:duration-100 hover:shadow-sh bg-[#5a8dee] text-white text-md rounded'>ورود</button>
                          </div>
                          <div className=''>
                              <span className='font-semibold text-md text-[#546990]'>  کاربر جدید هستید؟</span>
                              <Link className='font-semibold text-md text-[#5a8dee]' to="/register">یک حساب بسازید </Link>
                          </div>
                          <div className='flex justify-center items-center '>
                              <span className=' h-1 flex bg-[#2F3B50] w-2/6'></span>
                              <span className='text-[#9992A3] text-center font-bold  w-1/6'>یا</span>
                              <span className=' h-1 flex bg-[#2F3B50] w-2/6'></span>
                          </div>
                          <div className='flex justify-center items-center *:px-4 *:text-3xl'>
                                <div className=''>
                                <span  className='bg-[#2b3751] group rounded hover:bg-white  flex w-10 h-10 justify-center items-center'><i class="ri-twitter-x-line  text-black"></i></span>
                                    
                                </div>
                                <div className=''>
                                   <span  className='bg-[#bc40305b] group rounded hover:bg-[#bc4030]  flex w-10 h-10 justify-center items-center'><i class="ri-facebook-fill group-hover:text-white  text-[#dd4b39]"></i></span>
                                   
                                </div>
                                <div className=''>
                                    <span  className='bg-[#264360] group rounded hover:bg-[#1DA1F2]  flex w-10 h-10 justify-center items-center'><i class="ri-instagram-fill group-hover:text-white  text-[#1da1f2]"></i></span>
                                </div>
                          </div>
                    </section>
              
              </section>
              <section className='bg-[#1C222F] h-full hidden md:flex w-2/3 justify-center items-center'>
                  <div className='flex flex-wrap w-full h-full justify-center items-center *:w-full '>
                        <div className='flex justify-center items-center'>
                          <figure className='h-full'>
                            <img className='object-contain w-full h-[550px]' src={pic} alt='image' />
                            
                          </figure>
                        </div>
                        <div className='flex justify-center items-center *:w-full flex-wrap text-center *:py-2 '>
                              <h2 className='text-[#D8DEEA] text-2xl' >چند کلیک تا شروع</h2>
                              <h3 className='text-[#a1b0cb]'><b className='px-1'>email:</b>admin@yahoo.com</h3>
                              <h3 className='text-[#a1b0cb]'><b className='px-1'>pass:</b>123456</h3>
                              <p  className='  flex justify-center' ><b></b><b></b> </p>
                       </div>
                  </div>
              </section>
             
        </section> 
    </>
  )
}
